import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Grid,
  Menu,
  MenuItem,
  Button,
  useTheme,
  ListItemIcon,
  ListItemText,
  Tabs,
  Tab,
  tabsClasses,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import {
  HDotsIcon,
  AdminPaypalIcon,
  AdminStripeIcon,
  AdminMasterIcon,
  AdminUnionIcon,
  AdminPayonerIcon,
  DollarIcon,
} from "../../../Svg";
import { makeStyles } from "@mui/styles";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdminFormModal } from "../../../components";
import { headersGet, headersPost } from "../../../Services/API";
import { AdminUrls, domain } from "../../../Services/Routes/API";
import { MainRoutes } from "../../../Services/Routes/App";
import { SERVICE_PROVIDER_ENUM } from "../../../Services/Enums";

const ServiceProviderListing = () => {
  const payments = [
    { svg: <AdminPaypalIcon /> },
    { svg: <AdminStripeIcon /> },
    { svg: <AdminMasterIcon /> },
    { svg: <AdminUnionIcon /> },
    { svg: <AdminPayonerIcon /> },
  ];
  const theme = useTheme();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [updateServiceProviderModal, setUpdateServiceProviderModal] =
    useState(false);
  const [serviceProviders, setServiceProviders] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [serviceProviderRow, setServiceProviderRow] = useState(null);
  const [tabValue, setTabValue] = useState("un_archived_service_providers");
  const [categorizedServicesProviders, setCategorizedServiceProviders] =
    useState({});

  const updateServiceProvider = (item) => {
    setServiceProviderRow(item);
    setUpdateServiceProviderModal(true);
  };

  const userModalHandlerClose = () => {
    setUpdateServiceProviderModal(false);
  };

  // Add Service Provider Modal

  const Form_Modal_List_For_Add_Service_Provider = [
    {
      formKey: "service_provider",
      name: "name",
      label: "Name",
      value: serviceProviderRow?.name || "",
      style: { paddingY: 0.5, fontSize: 4 },
    },

    {
      formKey: "service_provider",
      name: "sub_type",
      label: "Service Provider",
      value: serviceProviderRow?.sub_type || "",
      type: "select",
      options: SERVICE_PROVIDER_ENUM,
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "service_provider",
      name: "client_secret",
      label: "Client Secret Key",
      value: serviceProviderRow?.client_secret || "",
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "service_provider",
      name: "client_id",
      label: "Client Id",
      value: serviceProviderRow?.client_id || "",
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "service_provider",
      name: "monthly_limit",
      label: "Monthly Transaction Limit",
      value: serviceProviderRow?.monthly_limit || "",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "service_provider",
      name: "daily_limit",
      label: "Daily Transaction Limit",
      value: serviceProviderRow?.daily_limit || "",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },

    {
      formKey: "service_provider",
      name: "average_ticket",
      label: "Avg Transaction Limit",
      value: serviceProviderRow?.average_ticket || "",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "service_provider",
      name: "monthly_service_fee",
      label: "Service Fee",
      value: serviceProviderRow?.monthly_service_fee || "",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "service_provider",
      type: "switch",
      name: "is_archived",
      value: serviceProviderRow?.is_archived || false,
      label: "Active & Inactive",
      handleChange: (e) => {},
    },
    {
      formKey: "service_provider",
      text: "Upload Logo",
      type: "file",
      name: "logo",
      style: {
        backgroundColor: "#FFA361",
        width: "40%",
        borderRadius: "1",
        padding: "1.5",
      },
    },
  ];

  const Form_Modal_Button_For_Add_Service_Provider = [
    {
      formKey: "service_provider",
      text: "Update",
      name: "update_service_provider",
      type: "submit",
      style: {
        backgroundColor: "#11A1EC",
        width: "100%",
        borderRadius: "1",
        padding: "1.5",
        marginBottom: "1rem",
      },
    },
  ];

  const useStyles = makeStyles({
    muiPaperShadowNone: {
      "& .MuiPaper-root": {
        boxShadow: "0px 3px 4px 0px rgb(30 63 138 / 3%)",
        minWidth: "100px",
      },
    },
  });

  const openn = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClosee = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  const getServiceProvidersListing = () => {
    setOpen(true);
    headersGet(AdminUrls.GET_SERVICE_PROVIDERS_LISTING)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setCategorizedServiceProviders(
            res?.data?.categorized_service_providers
          );
          setOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  // Update Service Provider

  const handleTabsChange = (event, newValue) => {
    setServiceProviders(categorizedServicesProviders?.[newValue]);
    setTabValue(newValue);
  };

  const updateServiceProviderHandler = (data) => {
    setOpen(true);
    headersPost(AdminUrls?.UPDATE_SERVICE_PROVIDER, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setUpdateServiceProviderModal(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getServiceProvidersListing();
  }, []);
  useEffect(() => {
    setTabValue("un_archived_service_providers");
    setServiceProviders(
      categorizedServicesProviders?.un_archived_service_providers
    );
  }, [categorizedServicesProviders]);
  const classes = useStyles();
  return (
    <Box mt={6}>
      <Box sx={{ width: "100%", backgroundColor: "white", marginBottom: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabsChange}
          variant="scrollable"
          //   scrollButtons
          sx={{
            [`& .${tabsClasses.scrollButtons}`]: {
              "&.Mui-disabled": { opacity: 0.3 },
            },
          }}
        >
          <Tab label="Active" value="un_archived_service_providers" />
          <Tab label="Inactive" value="archived_service_providers" />
        </Tabs>
      </Box>
      <Grid container spacing={2}>
        {serviceProviders?.map((row, index) => (
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <Paper sx={{ paddingBottom: 3 }}>
              <Box display={"flex"} justifyContent={"right"}>
                {" "}
                <Button
                  // id={`basic-button-${row?.id}`}
                  // aria-haspopup="true"
                  onClick={() => {
                    updateServiceProvider(row);
                  }}
                  // variant="outlined"
                  // onClick={() => addHandler(row)}
                  sx={{
                    borderRadius: 1,
                    minWidth: 0,
                    backgroundColor: "transparent",
                    padding: 1,
                    color: "#828282",
                  }}
                >
                  <EditIcon fontSize="small" />
                </Button>
                {/* <Menu
                  id={`basic-menu-${row?.id}`}
                  anchorEl={anchorEl}
                  open={anchorEl?.id === `basic-button-${row?.id}`}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  className={classes.muiPaperShadowNone}
                >
                  <MenuItem>
                    <ListItemIcon>
                      {" "}
                      <EditIcon />
                    </ListItemIcon>
                    <ListItemText
                      onClick={() => {
                        updateServiceProvider(row);
                      }}
                    >
                      Edit
                    </ListItemText>
                  </MenuItem>
                  <MenuItem>
                    <ListItemIcon>
                      {" "}
                      <DeleteIcon />
                    </ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                  </MenuItem>
                </Menu> */}
              </Box>
              <Box display={"flex"} justifyContent={"center"} minHeight={220}>
                {" "}
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                >
                  <img
                    src={domain + row?.logo}
                    alt={"logo"}
                    height={150}
                    width={150}
                  />
                  {/* {row?.svg} */}
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <AdminFormModal
        open={updateServiceProviderModal}
        onClose={userModalHandlerClose}
        MainHeading={"Update Service Provider"}
        TextFieldArray={Form_Modal_List_For_Add_Service_Provider}
        ButtonsArray={Form_Modal_Button_For_Add_Service_Provider}
        initialFormData={{
          service_provider: {
            id: serviceProviderRow?.id,
          },
        }}
        onSubmit={updateServiceProviderHandler}
      />
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClosee}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClosee} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ServiceProviderListing;
